import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './Components/ProtectedRoute';
import Layout from './Components/Layout';
import Login from './screens/Login';
import AdminDashboard from './screens/Admin';
import AprovMusica from './screens/AprovMusica';
import AttPerfil from './screens/AttPerfil';
import ValidacoesPendentes from './screens/ValidacoesPendentes';
import DenunciasAdmin from './screens/DenunciasAdmin';
import MensagensAjuda from './screens/MensagensAjuda';
import AnalyticsDashboard from './screens/AnalyticsDashboard';
import PlayAnalytics from './screens/PlayAnalytics';
import PushGeral from './screens/PushGeral';
import TribosPendentes from './screens/TribosPendentes';
import TribosAtivas from './screens/TribosAtivas';
import RedesSociais from './screens/RedesSociais';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Layout>
                  <AdminDashboard />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/aprovacao-musicas"
            element={
              <ProtectedRoute>
                <Layout>
                  <AprovMusica />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/atualizacao-perfis"
            element={
              <ProtectedRoute>
                <Layout>
                  <AttPerfil />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/denuncias"
            element={
              <ProtectedRoute>
                <Layout>
                  <DenunciasAdmin />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/mensagens-ajuda"
            element={
              <ProtectedRoute>
                <Layout>
                  <MensagensAjuda />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/estatisticas"
            element={
              <ProtectedRoute>
                <Layout>
                  <AnalyticsDashboard />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/validacoes-pendentes"
            element={
              <ProtectedRoute>
                <Layout>
                  <ValidacoesPendentes />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/play-analytics"
            element={
              <ProtectedRoute>
                <Layout>
                  <PlayAnalytics />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/push-geral"
            element={
              <ProtectedRoute>
                <Layout>
                  <PushGeral />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/tribos-pendentes"
            element={
              <ProtectedRoute>
                <Layout>
                  <TribosPendentes />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/tribos-ativas"
            element={
              <ProtectedRoute>
                <Layout>
                  <TribosAtivas />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/publicacoes-sociais"
            element={
              <ProtectedRoute>
                <Layout>
                  <RedesSociais />
                </Layout>
              </ProtectedRoute>
            }
          />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
